import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  inject,
  Input,
} from '@angular/core';
import { Highlightable } from '@angular/cdk/a11y';
import { DocPrepDocument } from '@et/typings';
import { PluralPipe } from '@et/shared';

@Component({
  selector: 'et-atoms-templates-search-list-item',
  imports: [PluralPipe],
  template: `
    <div class="truncate flex flex-col">
      <p class="m-0 truncate">
        {{ template.templateInfo.name }}
      </p>
      <p class="m-0 text-midnight/60 text-xs font-medium">
        @if (template.metadata.buyers) {
        <span>
          {{ template.metadata.buyers }}
          {{ template.metadata.buyers | plural : 'Buyer' }}
          &#183;
        </span>
        } @if (template.metadata.sellers) {
        <span>
          {{ template.metadata.sellers }}
          {{ template.metadata.sellers | plural : 'Seller' }}
          &#183;
        </span>
        } @if (!template.metadata.buyers && !template.metadata.sellers &&
        template.metadata.signors) {
        <span>
          {{ template.metadata.signors }}
          {{ template.metadata.signors | plural : 'Signer' }} &#183;
        </span>
        }
        <span>
          {{ template.numberOfPages }}
          {{ template.numberOfPages ?? 0 | plural : 'Page' }}
        </span>
      </p>
    </div>
  `,
  styles: [
    `
      :host {
        @apply block px-4 py-2 cursor-pointer hover:bg-base-100;
        &.active {
          @apply bg-base-100;
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplatesSearchListItemComponent implements Highlightable {
  private elementRef = inject(ElementRef);

  @Input({ required: true }) template!: DocPrepDocument;

  @HostBinding('class.active')
  active = false;

  /**
   * Sets the active styles for the list item.
   */
  setActiveStyles(): void {
    this.active = true;
    this.scrollIntoView();
  }

  /**
   * Sets the inactive styles for the list item.
   */
  setInactiveStyles(): void {
    this.active = false;
  }

  /**
   * Gets the label for the list item.
   */
  getLabel(): string {
    return this.template.templateInfo.name;
  }

  /**
   * Scrolls the list item into view.
   */
  private scrollIntoView() {
    this.elementRef.nativeElement.scrollIntoView({ block: 'center' });
  }
}
